import React from "react";
import { Box, Typography } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";

// const STATIC_LINKS = [
//   { label: "Privacy Policy", to: "/privacy-policy" },
//   { label: "Term and conditions", to: "/terms-of-service" },
// ];

const linkSx = {
  fontSize: "13px",
  color: "#64748b",
  textDecoration: "none",
  "&:hover": { color: "#17332F" },
};

export default function MiniFooter() {
  return (
    <Box
      component="footer"
      sx={{
        flexShrink: 0,
        borderTop: "1px solid #E8E8E8",
        mt: 1,
        pt: 1,
        /* Mobile/tablet: 2-column split */
        display: { xs: "grid", md: "flex" },
        gridTemplateColumns: { xs: "1fr 1fr", md: undefined },
        columnGap: { xs: 2, md: undefined },
        rowGap: { xs: "6px", md: undefined },
        /* Desktop: single row */
        flexWrap: { md: "wrap" },
        alignItems: { md: "center" },
        gap: { md: "24px" },
      }}
    >
      {/* Left column (col 1): Copyright + Privacy Policy */}
      <Typography sx={{ ...linkSx, gridColumn: { xs: 1 } }}>
        Copyright &copy; ETF India
      </Typography>

      <Typography
        component={RouterLink}
        to="/privacy-policy"
        sx={{ ...linkSx, gridColumn: { xs: 1 } }}
      >
        Privacy Policy
      </Typography>

      {/* Right column (col 2): Term and conditions + Contact us */}
      <Typography
        component={RouterLink}
        to="/terms-of-service"
        sx={{ ...linkSx, gridColumn: { xs: 2 }, gridRow: { xs: 1 } }}
      >
        Terms and conditions
      </Typography>

      <Typography
        component={RouterLink}
        to="/contact"
        onClick={() =>
          sessionStorage.setItem("contactReferrer", window.location.href)
        }
        sx={{ ...linkSx, gridColumn: { xs: 2 }, gridRow: { xs: 2 } }}
      >
        Contact us
      </Typography>
    </Box>
  );
}
